import { render, staticRenderFns } from "./CreateupdateCustomer.vue?vue&type=template&id=67fad794&"
import script from "./CreateupdateCustomer.vue?vue&type=script&lang=js&"
export * from "./CreateupdateCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports